// =============================================================
// caly_KulturDaten.js – gemeinsame Kultur-Werte für die neuen
// Jobs-Seiten (jobs2.js und templates/job2.js)
//
// Die Icon-Bilder sind pixelgenau aus dem XD-Design von Florian
// (KR8 bureau) übernommen. Texte laut XD-Design.
// =============================================================

import caly_iconBezahlung from '../images/pixels/extendit-kultur-1.png'
import caly_iconBalance from '../images/pixels/extendit-kultur-2.png'
import caly_iconEvents from '../images/pixels/extendit-kultur-3.png'
import caly_iconBuero from '../images/pixels/extendit-kultur-4.png'
import caly_iconFortbildung from '../images/pixels/extendit-kultur-5.png'
import caly_iconKommunikation from '../images/pixels/extendit-kultur-6.png'

// 6 Kultur-Werte mit Icon-Bild und Beschreibungstext
const caly_kulturDaten = [
  {
    id: 'k1',
    bild: caly_iconBezahlung,
    text: 'Faire Bezahlung mit tollen Chancen in der beruflichen Weiterentwicklung.',
  },
  {
    id: 'k2',
    bild: caly_iconBalance,
    text: 'Fokus auf Work-Life-Balance und eine gesunde Arbeitseinstellung.',
  },
  {
    id: 'k3',
    bild: caly_iconEvents,
    text: 'Regelmäßige Team-Events und Team-Building.',
  },
  {
    id: 'k4',
    bild: caly_iconBuero,
    text: 'Schöner, heller Arbeitsplatz in unserem Loftbüro im 7. Bezirk in Wien.',
  },
  {
    id: 'k5',
    bild: caly_iconFortbildung,
    text: 'Chancen auf regelmäßige Fortbildung und Ausbildung.',
  },
  {
    id: 'k6',
    bild: caly_iconKommunikation,
    text: 'Transparente Kommunikation in einem kleinen, freundlichen Team.',
  },
]

export default caly_kulturDaten
